/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import { ModalContext } from "../../context/modal";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";

function EditBot({ open, populateTable, data, spreadAccounts }) {
	const inputRef = useRef(null);
	const { handleOpenModal } = useContext(ModalContext);

	async function handleEditBot() {
		try {
			await authApi.post(`/bot-builder/edit/${data.bot}`, {
				botName: inputRef?.current.value,
			});
			toast.success("O bot foi editado com sucesso", TOASTIFY_OPTIONS);
			populateTable();
			handleOpenModal();
		} catch (error) {
			toast.error("Erro ao editar bot", TOASTIFY_OPTIONS);
		}
	}

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = data.botName;
		}
	}, [inputRef.current]);

	return (
		<Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Editar: {data?.botName}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<div>
						<label htmlFor="">Nome do bot</label>
						<MyModalInput
							name="name"
							placeholder="ex: Bot-cliente"
							ref={inputRef}
						/>
					</div>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleEditBot}>Editar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { EditBot };
